import { useState } from "react";

export const usePaymentState = () => {
  const [priceType, setPriceType] = useState<"full" | "deposit" | string>(
    "deposit",
  );
  const [isLoading, setIsLoading] = useState(false);

  const [cardNumberReady, setCardNumberReady] = useState(false);
  const [cvcReady, setCvcReady] = useState(false);
  const [expiryReady, setExpiryReady] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [inputErrorMessage, setInputErrorMessage] = useState({
    cardNumber: "",
    expiry: "",
    cvc: "",
  });

  const [cardNumberComplete, setCardNumberComplete] = useState(false);
  const [cvcComplete, setCvcComplete] = useState(false);
  const [expiryComplete, setExpiryComplete] = useState(false);

  return {
    priceType,
    setPriceType,
    isLoading,
    setIsLoading,
    cardNumberReady,
    setCardNumberReady,
    cvcReady,
    setCvcReady,
    expiryReady,
    setExpiryReady,
    cardNumberComplete,
    setCardNumberComplete,
    cvcComplete,
    setCvcComplete,
    expiryComplete,
    setExpiryComplete,
    errorMessage,
    setErrorMessage,
    inputErrorMessage,
    setInputErrorMessage,
  };
};
